import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../lib/breadcrumbs';

/**
 * Renderless component — pushes a `route` breadcrumb every time the URL
 * changes. Mount it once inside <BrowserRouter>.
 */
export default function RouteTracker() {
  const location = useLocation();
  const prevRef = useRef(null);

  useEffect(() => {
    const to = `${location.pathname}${location.search}${location.hash}`;
    track('route', { to, from: prevRef.current });
    prevRef.current = to;
  }, [location.pathname, location.search, location.hash]);

  return null;
}
